import { render, staticRenderFns } from "./otaInstrodution.vue?vue&type=template&id=0deca408&scoped=true"
import script from "./otaInstrodution.vue?vue&type=script&lang=js"
export * from "./otaInstrodution.vue?vue&type=script&lang=js"
import style0 from "./otaInstrodution.vue?vue&type=style&index=0&id=0deca408&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deca408",
  null
  
)

export default component.exports